import React from "react"

const LocationInfo = ({ location }) => {
  const block = "max-w-42 normal-case"
  const heading = "font-bold uppercase mb-2"
  return (
    <>
      <div className={block}>
        <h3 className={heading}>{location.location}</h3>
        <span className="whitespace-pre-wrap">{location.address}</span>
        <br />
        <span>
          <a href={`tel:${location.phoneNo}`}> {location.phoneNo}</a>
        </span>
      </div>
      {location.openingHours ? (
        <div className={block}>
          <h3 className={heading}>opening hours</h3>
          <span className="whitespace-pre-wrap">{location.openingHours}</span>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default LocationInfo
